// extracted by mini-css-extract-plugin
module.exports = {"btnToast":"toast_btnToast__1G1AD","toast":"toast_toast__WLizo","detail":"toast_detail__2jbz7"};